/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line
  document.addEventListener('theme:product:added', () => {
  console.log('theme:product:added');
  });
  document.addEventListener('theme:product:added', async () => {
    const wrapper = document.querySelector('[data-announcement-wrapper]');

    if (!wrapper) return;

    const sectionId = wrapper.dataset.sectionId;

    try {
      const response = await fetch(`${window.location.pathname}?section_id=${sectionId}`);
      const html = await response.text();

      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');

      const newWrapper = doc.querySelector('[data-announcement-wrapper]');

      if (!newWrapper) return;

      wrapper.replaceWith(newWrapper);

      document.dispatchEvent(
        new CustomEvent('theme:announcement:init', {
          bubbles: true
        })
      );
    } catch (e) {
      console.error('Announcement refresh failed', e);
    }
  });

  const updateShipBarHeight = () => {
  const shipBar = document.querySelector('.tos-ship-bar');
  const height = shipBar ? shipBar.offsetHeight : 0;

  document.documentElement.style.setProperty(
    '--tos-ship-bar-height',
    `${height}px`
  );
  };

  updateShipBarHeight();

  window.addEventListener('resize', updateShipBarHeight);


  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();


/* ===== Language and currency go together =====
   Korean -> South Korea (KRW). Japanese -> Japan (JPY).
   English -> United Kingdom (GBP) by default, United States (USD) for visitors detected in the US.
   Picking a currency switches the language to match (KRW -> Korean, JPY -> Japanese, GBP/USD -> English). */
(function() {
  var LANG_TO_COUNTRY = { ko: 'KR', ja: 'JP' };
  var COUNTRY_TO_LANG = { KR: 'ko', JP: 'ja', GB: 'en', US: 'en' };
  var EN_COUNTRIES = ['GB', 'US'];
  var FROM_CURRENCY = 'tos-pair-from-currency';
  var GEO_DONE = 'tos-pair-geo-done';
  var LAST_TRY = 'tos-pair-last-try';

  function store(kind) { try { return window[kind]; } catch (e) { return null; } }
  function get(kind, k) { try { var s = store(kind); return s ? s.getItem(k) : null; } catch (e) { return null; } }
  function set(kind, k, v) { try { var s = store(kind); if (s) { v === null ? s.removeItem(k) : s.setItem(k, v); } } catch (e) {} }

  function country() { return (window.Shopify && window.Shopify.country) || null; }

  function setCountry(code) {
    if (!code || code === country()) return;
    // Guard against a reload loop if the market change does not take.
    var last = get('sessionStorage', LAST_TRY);
    if (last) {
      var p = last.split('|');
      if (p[0] === code && Date.now() - Number(p[1]) < 15000) return;
    }
    set('sessionStorage', LAST_TRY, code + '|' + Date.now());
    var f = document.createElement('form');
    f.method = 'post';
    f.action = '/localization';
    f.style.display = 'none';
    [['form_type', 'localization'], ['utf8', '\u2713'], ['_method', 'put'], ['country_code', code],
     ['return_to', window.location.pathname + window.location.search]].forEach(function(kv) {
      var i = document.createElement('input');
      i.type = 'hidden'; i.name = kv[0]; i.value = kv[1];
      f.appendChild(i);
    });
    document.body.appendChild(f);
    f.submit();
  }

  function detectEnglishCountry() {
    return fetch('/browsing_context_suggestions.json?country[enabled]=true')
      .then(function(r) { return r.json(); })
      .then(function(j) {
        var c = j && j.detected_values && j.detected_values.country && j.detected_values.country.handle;
        return c === 'US' ? 'US' : 'GB';
      })
      .catch(function() { return 'GB'; });
  }

  function syncToLanguage(lang) {
    if (LANG_TO_COUNTRY[lang]) { setCountry(LANG_TO_COUNTRY[lang]); return; }
    if (lang !== 'en') return;
    var c = country();
    // A GBP/USD choice already made stays. Otherwise pick by location once.
    if (EN_COUNTRIES.indexOf(c) > -1 && get('localStorage', GEO_DONE)) return;
    detectEnglishCountry().then(function(target) {
      set('localStorage', GEO_DONE, '1');
      if (EN_COUNTRIES.indexOf(c) > -1 && !LANG_TO_COUNTRY[lang] && c === target) return;
      setCountry(target);
    });
  }

  // Remember when the shopper picks a currency, so the language follows it after the reload.
  document.addEventListener('click', function(e) {
    var opt = e.target.closest && e.target.closest('[data-tos-currency-list] [data-popout-option]');
    if (!opt) return;
    set('sessionStorage', FROM_CURRENCY, opt.getAttribute('data-value') || '1');
    set('localStorage', GEO_DONE, '1');
  }, true);

  function start(W) {
    var picked = get('sessionStorage', FROM_CURRENCY);
    set('sessionStorage', FROM_CURRENCY, null);
    var lang = W.getCurrentLang();
    if (picked) {
      var want = COUNTRY_TO_LANG[country()];
      if (want && want !== lang) W.switchTo(want);
    } else {
      syncToLanguage(lang);
    }
    W.on('languageChanged', function(newLang) { syncToLanguage(newLang); });
  }

  var tries = 0;
  (function wait() {
    var W = window.Weglot;
    if (W && W.initialized && W.getCurrentLang) { start(W); return; }
    if (W && W.on && !W.initialized && tries === 0) { W.on('initialized', function() { start(window.Weglot); }); tries = 999; return; }
    if (++tries < 100) setTimeout(wait, 100);
  })();
})();
